/**
 * Trade-show marketing pages.
 * Live show/banner config is loaded from /api/marketing (admin-editable).
 * Static helpers remain for tests and fallbacks.
 */

export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.dejavunomad.app';
export const APP_STORE_URL =
  'https://apps.apple.com/us/app/deja-vu-nomad-mobile/id6756630318';

/** @deprecated Prefer API /api/marketing/shows — kept for tests / redirects */
export const MARKETING_EVENTS = {
  cruiseworld: {
    id: 'cruiseworld',
    path: '/shows/cruiseworld',
    source: 'cruiseworld',
    heroImage:
      'https://images.unsplash.com/photo-1548574505-5e239809ee19?auto=format&fit=crop&w=2000&q=80',
    splitImage:
      'https://images.unsplash.com/photo-1548574505-5e239809ee19?auto=format&fit=crop&w=1400&q=80',
    dates: '4–6 November 2026',
    venue: 'Greater Fort Lauderdale / Broward County Convention Center',
    showInSitemap: true,
  },
};

export const SHOWS_HUB = {
  path: '/shows',
};

/** @deprecated Use SHOWS_HUB */
export const WTM_HUB = SHOWS_HUB;

export const getMarketingEvent = (eventId) => MARKETING_EVENTS[eventId] || null;

export const getAllMarketingEvents = () => Object.values(MARKETING_EVENTS);

/**
 * Map API marketing show → shape used by EventMarketingPage / hub.
 */
export const mapApiShowToEvent = (show) => {
  if (!show) return null;
  return {
    id: show.slug,
    slug: show.slug,
    path: show.path || `/shows/${show.slug}`,
    source: show.source || show.slug,
    heroImage: show.heroImageUrl,
    splitImage: show.splitImageUrl || show.heroImageUrl,
    dates: show.datesLabel,
    venue: show.venue,
    name: show.name,
    hubTitle: show.hubTitle || show.name,
    hubSubtitle: show.hubSubtitle,
    hubCta: show.hubCta || 'Explore',
    copy: {
      seo: {
        title: show.seoTitle || `Meet Déjà Vu Nomad at ${show.name}`,
        description: show.seoDescription || '',
        keywords: show.seoKeywords || '',
      },
      hero: {
        event: show.heroEyebrow || [show.name, show.datesLabel].filter(Boolean).join(' · '),
        title: show.heroTitle || 'Travel smarter. Partner smarter.',
        subtitle: show.heroSubtitle || '',
      },
      agents: {
        title: show.agentsTitle || `Grow your business at ${show.name}`,
        subtitle: show.agentsSubtitle || '',
      },
      interest: {
        title: show.interestTitle || `Meet us at ${show.name}`,
        subtitle: show.interestSubtitle || '',
        submit: show.interestSubmit || `Join the ${show.name} interest list`,
      },
      demo: {
        badge: 'Book a meeting',
        title: show.demoTitle || `Book a meeting at ${show.name}`,
      },
      finalCta: {
        title: 'Ready to get started?',
        subtitle:
          show.finalCtaSubtitle ||
          `Travelers can create a free account in minutes. Travel professionals can join and meet us at ${show.name}.`,
      },
    },
  };
};
